import React, { useState, useEffect } from "react"
import { Row, Col, Card, CardBody } from "reactstrap"
import PropTypes from "prop-types"

import { retrieveValues } from "../../helpers/storagewrapper.js"

//i18n
import { withTranslation } from "react-i18next"
// Redux
import { connect } from "react-redux"
import { withRouter, Link } from "react-router-dom"

//Import Images
import avatar1 from "../../assets/images/users/avatar-1.jpg"

function CardUser(props) {
  const [settingsMenu, setSettingsMenu] = useState(false)
  const [username, setusername] = useState("Admin")

  useEffect(() => {
    if (retrieveValues("authUser")) {
      const obj = JSON.parse(retrieveValues("authUser"))
      let str = obj?.data?.name || ""
      let acronym = str
        .split(/\s/)
        .reduce((response, word) => (response += word.slice(0, 1)), "")
      setusername(acronym)
    }
  }, [props.success])
  //Setting Menu
  const toggleSettings = () => {
    setSettingsMenu(settingsMenu)
  }

  return (
    <React.Fragment>
      <Row>
        <Col lg="12">
          <Card>
            <CardBody>
              <Row>
                <Col lg="10">
                  <div className="d-flex">
                    <div className="me-3">
                      <div className={"avatar-md"}>
                        <span
                          className={`avatar-title rounded-circle font-size-20 ${"bg-success"}`}
                          style={{ color: "#fff" }}
                        >
                          {(username || "AS").toUpperCase().substr(0, 2)}
                        </span>
                      </div>
                    </div>
                    <div className="flex-grow-1 align-self-center">
                      <div className="text-muted">
                        <h5 className="mb-1">Sarah Sim</h5>
                        <p className="mb-0">Carpark Administrator</p>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col lg="2" className="d-none d-lg-block">
                  <div className="clearfix mt-4 mt-lg-0 text-center">
                    <Link to="#" className="btn btn-primary ">
                      Edit Profile
                    </Link>
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  )
}

CardUser.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any,
}

const mapStatetoProps = state => {
  const { error, success } = state.Profile
  return { error, success }
}

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(CardUser))
)
